import { render, staticRenderFns } from "./MedicationForm.vue?vue&type=template&id=0ea23ac9&"
import script from "./MedicationForm.vue?vue&type=script&lang=js&"
export * from "./MedicationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports